import { useEffect, useState } from 'react';

/**
 * Hook to delay initialization until after initial mount.
 * Simplified to start as soon as possible while still allowing the shell to render.
 */
export const useDelayedInitialization = (delayMs: number = 0) => {
  const [shouldInitialize, setShouldInitialize] = useState(false);

  useEffect(() => {
    // Start initialization almost immediately, but after the first paint
    const timer = setTimeout(() => {
      setShouldInitialize(true);
    }, delayMs);

    return () => clearTimeout(timer);
  }, [delayMs]);

  return shouldInitialize;
};

